import { HardDriveDownload } from "lucide-react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { Button } from "@/components/ui/button";
import { toast } from "@/components/ui/sonner";
import { api, fetchCollection, formatApiError } from "@/lib/api";

export function MediaMirrorCard() {
  const queryClient = useQueryClient();
  const status = useQuery({
    queryKey: ["media-mirror"],
    queryFn: () => fetchCollection("/admin/media/mirror"),
    refetchInterval: (query) => (query.state.data?.running ? 5000 : false),
  });
  const start = useMutation({
    mutationFn: async () => (await api.post("/admin/media/mirror")).data,
    onSuccess: (data) => {
      toast.success(data.started ? "Copia de fotografías iniciada" : "La copia ya está en marcha");
      queryClient.invalidateQueries({ queryKey: ["media-mirror"] });
    },
    onError: (error) => toast.error(formatApiError(error)),
  });
  const data = status.data || {};
  const percent = data.total ? Math.round((data.done / data.total) * 100) : 0;
  const label = { running: "Copiando…", finished: "Copia completada", error: "Error en la copia", idle: "Sin iniciar" }[data.status] || "Sin iniciar";

  return (
    <div className="grid gap-4 border border-white/10 bg-white/[0.03] p-5 md:grid-cols-[1fr_auto] md:items-center" data-testid="media-mirror-card">
      <div>
        <p className="eyebrow">Fotografías de WordPress → almacenamiento propio</p>
        <p className="mt-2 text-sm text-slate-300" data-testid="media-mirror-status">
          {label}{data.total ? ` · ${data.done}/${data.total} archivos · ${data.uploaded} copiados · ${data.duplicates} duplicados descartados${data.errors ? ` · ${data.errors} errores` : ""}` : ""}
          {data.status === "finished" && data.rewritten != null ? ` · ${data.rewritten} entradas apuntan ya a las copias propias` : ""}
        </p>
        <div className="mt-3 h-1.5 w-full bg-white/10" data-testid="media-mirror-progress">
          <div className="h-full bg-clay transition-[width] duration-700" style={{ width: `${percent}%` }} />
        </div>
      </div>
      <Button type="button" onClick={() => start.mutate()} disabled={start.isPending || data.running} variant="outline" className="rounded-none border-white/15 bg-white/[0.03] font-mono text-xs uppercase tracking-[0.2em] text-slate-100 hover:border-clay/60 hover:bg-clay/10 hover:text-clay" data-testid="media-mirror-start-button">
        {data.running ? `${percent}%` : data.status === "finished" ? "Repetir copia" : "Copiar fotografías"} <HardDriveDownload className="h-4 w-4" />
      </Button>
    </div>
  );
}
